import { LoadingProps } from '@/helper/common/interface';
const types = {
  UPDATE: 'update',
};
interface ActionProps {
  type?: string;
  payload?: any;
}
const initState: LoadingProps = {
  isShow: false,
};

const loadingReducer = (state = initState, action: ActionProps = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default loadingReducer;

export const loadingActions = {
  setLoading: function (payload: object) {
    return { type: types.UPDATE, payload };
  },
};
